export const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/points-watch`;
export const opts = { withCredentials: true };
export const FLAG_META = {
  spike: { label: '⚡ SPIKE', cls: 'border-[#FF9F0A] text-[#FF9F0A]', tip: 'Earned far more than the previous period' },
  referral_farm: { label: '👥 REFERRAL FARM', cls: 'border-[#FF3B30] text-[#FF3B30]', tip: 'Many referrals, few paying' },
  like_ring: { label: '🔁 LIKE RING', cls: 'border-[#B400FF] text-[#B400FF]', tip: 'Mutual likes or one heavy liker' },
  tier_candidate: { label: '🏆 TIER CANDIDATE', cls: 'border-[#39FF14] text-[#39FF14]', tip: 'High earner, mostly from orders' },
};
export const SOURCE_META = { orders: '🛒', referrals: '👥', reviews: '⭐', likes: '🔥', bonus: '🎁' };
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' }) : '—');
export const customerLink = (id) => `/dispatch/admin/users?openUser=${id}&from=points-watch`;
export const orderLink = (id) => `/dispatch?orderId=${id}`;

const TIER_META = {
  standard: ['NEW', '#8E8E93'], silver: ['SILVER', '#C0C0C0'], gold: ['GOLD', '#FFD700'],
  platinum: ['PLATINUM', '#E5E4E2'], onyx: ['ONYX', '#BF5AF2'], black_card: ['BLACK CARD', '#FFFFFF'],
};

export function TierChip({ tier, testId }) {
  const [label, color] = TIER_META[tier] || TIER_META.standard;
  const black = tier === 'black_card';
  return (
    <span className="px-1 border font-mono text-[9px] font-bold whitespace-nowrap align-middle" style={{ color, borderColor: color, background: black ? '#000' : `${color}1A` }} data-testid={testId}>
      {label}
    </span>
  );
}

export function FlagChip({ flag }) {
  const m = FLAG_META[flag];
  return <span title={m.tip} className={`px-1 py-0 border font-mono text-[9px] font-bold whitespace-nowrap ${m.cls}`} data-testid={`watch-flag-${flag}`}>{m.label}</span>;
}
